/*
 * Developed for EPSON AMERICA INC. by Softeq Development Corporation
 * http://www.softeq.com
 */

import React from 'react'
import { Field } from 'redux-form'
import { Link } from 'react-router-dom'
import classNames from 'classnames/bind'
import { ROUTES } from 'constants/routes'
import { MAX_LENGTHS } from 'constants/forms'
import { Text as TextType, GetTextPath } from 'hocs/localization'
import AuthPage from 'apps/AuthPage'
import { Input, Captcha } from 'apps/FormFields'
import Button from 'elements/Button'
import {
  createValidation,
  createValidator,
  hasValidEmail,
  removeSpaces,
} from 'utils/form'
import SuccessForgotPassEmailSending from './apps/SuccessForgotPassEmailSending'
import * as styles from './ForgotPasswordForm.scss'

const cx = classNames.bind(styles)

interface IProps {
  t: TextType,
  getTextPath: GetTextPath,
  handleSubmit: any,
  valid: boolean,
  submitting: boolean,
  isSent: boolean,
  captchaRef: (ref: React.ReactElement<any>) => React.Ref<any>,
  captchaFieldName: string,
  onVerifyCaptcha: (response: string) => void,
  isCaptchaEnabled: boolean,
  isCaptchaWhiteListed: boolean,
  isCaptchaVerified: boolean,
}

class ForgotPasswordForm extends React.Component<IProps, {}> {
  public emailValidation = createValidation([
    createValidator(hasValidEmail, this.props.getTextPath('errors.email')),
  ])

  public render () {
    const {
      t,
      captchaRef,
      captchaFieldName,
      handleSubmit,
      onVerifyCaptcha,
      valid,
      submitting,
      isSent,
      isCaptchaEnabled,
      isCaptchaWhiteListed,
      isCaptchaVerified,
    } = this.props

    return (
      <AuthPage styleType={isSent ? 'success' : ''}>
        {isSent ? <SuccessForgotPassEmailSending/> : (
          <form className={styles.ForgotPasswordForm} onSubmit={handleSubmit}>
            <Field
              disabled={submitting}
              name='email'
              type='text'
              component={Input}
              validate={this.emailValidation}
              maxLength={MAX_LENGTHS.email}
              normalize={removeSpaces}
              label={t('emailLabel')}
            />
            {(isCaptchaEnabled && !isCaptchaWhiteListed) && (
              <div className={cx('FormField', 'centered')}>
                <Field
                  captchaRef={captchaRef}
                  name={captchaFieldName}
                  component={Captcha}
                  verifyCallback={onVerifyCaptcha}
                />
              </div>
            )}
            <div className={styles.submitButton}>
              <Button
                fluid
                disabled={!valid || (isCaptchaEnabled && !isCaptchaWhiteListed && !isCaptchaVerified) || submitting}
              >
                {submitting ? t('submitButtonSubmitting') : t('submitButton')}
              </Button>
            </div>
            <div className={styles.alreadyLogin}>
              <Link to={ROUTES.home.logIn}>{t('backToLogin')}</Link>
            </div>
          </form>
        )}
      </AuthPage>
    )
  }
}

export default ForgotPasswordForm
